import { render, staticRenderFns } from "./VerifyTransaction.vue?vue&type=template&id=6d858889"
import script from "./VerifyTransaction.vue?vue&type=script&lang=js"
export * from "./VerifyTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports